import { changeVideoUrl, conditions, secondsToHMS, unitization } from "helpers";
import { ConditionName } from "interfaces";
import Image from "next/image";
import { useEffect, useRef, useState } from "react";
import { useAppDispatch, useAppSelector } from "redux-share";
import { setIsAutoPlay } from "redux-share/slices/controllerSlice";
import { setAutoPlayPopover, setRecommendListPopover } from "redux-share/slices/popoversSlice";
import CloseIcon from "../../icon-components/closeIcon";
import IMAGES from "../../../../../images/importImages";
import { shallowEqual } from "react-redux";
import dynamic from "next/dynamic";

const Popover = dynamic(() => import("../popover/popover"));

const AutoPlay = () => {
    const [autoPlayCounter, setAutoPlayCounter] = useState<number>(10);
    const [showSingleNextPlayList, setShowSingleNextPlayList] = useState<boolean>(conditions(ConditionName.isAutoPlay));
    const [mouseOverId, setMouseOverId] = useState<number | undefined>(undefined);
    const [videoCounts, setVideoCounts] = useState<number>(12);
    const [gridStyle, setGridStyle] = useState<string>(`pl-grid-cols-4`);

    const dispatch = useAppDispatch();
    const { recommendationList } = useAppSelector(
        ({ videoData: { recommendationList, isComplexPortrait } }) => ({ recommendationList, isComplexPortrait }),
        shallowEqual
    );
    const { recommendListPopover } = useAppSelector(({ popovers: { recommendListPopover } }) => ({ recommendListPopover }), shallowEqual);
    const { isAutoPlay, isEnded } = useAppSelector(({ controller: { isAutoPlay, isEnded } }) => ({ isAutoPlay, isEnded }), shallowEqual);

    const autoPlayCounterRef = useRef<number>(autoPlayCounter);
    const intervalRef = useRef<any>(null);
    const recommendationListFiltered = recommendationList.filter((item: any) => item.type !== "playlist");

    useEffect(() => {
        setShowSingleNextPlayList(conditions(ConditionName.isAutoPlay));
    }, [isAutoPlay]);

    useEffect(() => {
        if (conditions(ConditionName.isTouchScreenLandscape)) setShowSingleNextPlayList(!conditions(ConditionName.showRecommendListPopover));
    }, [recommendListPopover]);

    useEffect(() => {
        autoPlayCounterRef.current = autoPlayCounter;
    }, [autoPlayCounter]);

    useEffect(() => {
        if (conditions(ConditionName.isAutoPlay)) {
            intervalRef.current = setInterval(() => {
                if (autoPlayCounterRef.current === 0) {
                    clearInterval(intervalRef.current);
                    window.location.href = changeVideoUrl();
                } else setAutoPlayCounter(autoPlayCounterRef.current - 1);
            }, 1000);
        } else {
            clearInterval(intervalRef.current);
            setAutoPlayCounter(10);
        }
    }, [isEnded, isAutoPlay]);

    useEffect(() => {
        const handleResize = () => {
            if (window.innerWidth < 1000) {
                setVideoCounts(2);
                setGridStyle(`pl-grid-cols-2`);
            } else if (window.innerWidth < 1400) {
                setVideoCounts(6);
                setGridStyle(`pl-grid-cols-3`);
            } else if (window.innerWidth >= 1400) {
                setVideoCounts(12);
                setGridStyle(`pl-grid-cols-4`);
            }
        };

        handleResize();
        window.addEventListener("resize", handleResize);

        () => window.removeEventListener("resize", handleResize);
    }, []);

    const handleClosePopover = (type: string) => {
        if (type === "single-popover") {
            dispatch(setIsAutoPlay(false));
            if (conditions(ConditionName.isTouchScreen)) {
                setShowSingleNextPlayList(false);
                dispatch(setRecommendListPopover(true));
            } else {
                localStorage.setItem("isAutoPlay", "false");
                setShowSingleNextPlayList(false);
            }
        } else {
            dispatch(setAutoPlayPopover(false));
            dispatch(setRecommendListPopover(false));
        }
    };

    let popoverContent = <div></div>;

    if (showSingleNextPlayList) {
        popoverContent = (
            <div
                className={`pl-w-full pl-h-full pl-absolute pl-top-0 pl-right-0 pl-flex pl-justify-center pl-items-center animate__animated animate__zoomIn pl-bg-black ${
                    conditions(ConditionName.isTouchScreen) ? "pl-absolute" : "pl-relative"
                }`}
            >
                <div className="pl-w-[90%] xl:pl-w-[50%] pl-flex pl-flex-col pl-justify-start pl-items-start">
                    <div className="pl-flex pl-justify-between pl-w-full">
                        <p className="pl-text-[14px] pl-font-medium pl-mb-2 pl-text-gray-400">
                            بعدی در <span className="pl-text-white">{autoPlayCounter}</span>
                        </p>
                        <CloseIcon className="pl-w-6 pl-h-6 pl-stroke-white pl-cursor-pointer" onClick={() => handleClosePopover("single-popover")} />
                    </div>
                    <div
                        className="pl-w-full xl:pl-w-full pl-flex pl-flex-row xl:pl-flex-col pl-gap-3"
                        onClick={() => (window.location.href = changeVideoUrl())}
                    >
                        <div className="pl-w-[50%] xl:pl-w-full pl-max-w-[1000px] pl-h-full pl-relative">
                            <Image
                                src={recommendationListFiltered[0].banner ? recommendationListFiltered[0].banner : IMAGES.sampleBanner}
                                layout="responsive"
                                width={200}
                                height={112.5}
                                className="pl-rounded-[10px] pl-cursor-pointer"
                            />
                        </div>
                        <p className="pl-cursor-pointer pl-text-[15px] pl-text-white pl-font-bold">{recommendationListFiltered[0].title}</p>
                    </div>
                    <div className="pl-w-full pl-flex pl-items-center pl-gap-4 pl-mt-3">
                        <button
                            className="pl-w-full pl-text-white pl-bg-main-light pl-rounded-[8px] pl-py-2 pl-cursor-pointer"
                            onClick={() => (window.location.href = changeVideoUrl())}
                        >
                            پخش
                        </button>
                        <button
                            className="pl-w-full pl-text-white pl-border-[1.5px] pl-rounded-[8px] pl-py-2 pl-cursor-pointer"
                            onClick={() => handleClosePopover("single-popover")}
                        >
                            انصراف
                        </button>
                    </div>
                </div>
            </div>
        );
    } else if (conditions(ConditionName.showRecommendListPopover) && conditions(ConditionName.isTouchScreenLandscape)) {
        popoverContent = (
            <div className="pl-w-screen pl-h-screen pl-flex pl-flex-col pl-justify-between pl-p-4">
                <CloseIcon className="pl-w-6 pl-h-6 pl-stroke-white" onClick={() => handleClosePopover("multi-popover")} />
                <div className="pl-flex pl-items-center pl-gap-2 pl-overflow-auto no-scrollbar">
                    {recommendationListFiltered.slice(0, 12).map((item: any) => (
                        <div
                            key={item.id}
                            className="pl-flex-none animate__animated animate__backInUp"
                            onClick={() => (window.location.href = changeVideoUrl(item.type, item.id))}
                        >
                            <Image src={item.banner ? item.banner : IMAGES.sampleBanner} width={184} height={103} className="pl-rounded-[4px]" />
                            <p className="pl-text-[12px] pl-text-white pl-font-bold pl-truncate pl-w-[184px]">{item.title}</p>
                        </div>
                    ))}
                </div>
            </div>
        );
    } else if (!conditions(ConditionName.isTouchScreen)) {
        popoverContent = (
            <div className={`pl-w-auto pl-h-full pl-grid ${gridStyle} pl-content-center pl-gap-2 pl-mx-[18px]`}>
                {recommendationListFiltered.slice(0, videoCounts).map((item: any) => (
                    <div
                        key={item.id}
                        className="pl-relative pl-w-full pl-h-full pl-rounded-[4px] pl-cursor-pointer animate__animated animate__zoomIn"
                        onMouseEnter={() => setMouseOverId(item.id)}
                        onMouseLeave={() => setMouseOverId(undefined)}
                        onClick={() => (window.location.href = changeVideoUrl(item.type, item.id))}
                    >
                        <Image
                            src={item.banner ? item.banner : IMAGES.sampleBanner}
                            layout="responsive"
                            width={200}
                            height={112.5}
                            className="pl-rounded-[4px]"
                        />
                        {mouseOverId === item.id && (
                            <div
                                className="pl-w-full pl-h-full pl-flex pl-flex-col pl-justify-between pl-absolute pl-top-0 pl-left-0 pl-pt-[13px] pl-px-[16px] pl-pb-[8px] pl-font-bold"
                                style={{ background: `linear-gradient(180deg, rgba(0, 0, 0, 0.6) 0%, rgba(4, 4, 18, 0) 100%` }}
                            >
                                <div className="pl-text-white">
                                    <p className="pl-text-[12px] pl-font-bold pl-two-line">{item.title}</p>
                                    <div className="pl-flex pl-gap-[7px] pl-text-[9px]">
                                        <p>
                                            <span>{unitization(item.viewers).value}</span>
                                            <span>{unitization(item.viewers).unit}</span>
                                        </p>
                                        <p>بازدید</p>
                                    </div>
                                </div>
                                <p className="pl-self-end pl-rounded-[4px] pl-px-[7.5px] pl-w-max pl-text-left pl-bg-black/[0.7] pl-text-[12px] pl-text-white pl-font-normal">
                                    {secondsToHMS(item.duration)}
                                </p>
                            </div>
                        )}
                    </div>
                ))}
            </div>
        );
    } else dispatch(setAutoPlayPopover(false));

    return (
        <>
            {conditions(ConditionName.isTouchScreen) ? (
                <Popover
                    status={true}
                    onClose={() => {}}
                    type="popover"
                    classNames={`pl-w-full pl-absolute pl-top-0 pl-right-0 !pl-bg-black/[0.8]`}
                    styles={{ height: conditions(ConditionName.isComplexPortrait) ? (window.innerWidth * 9) / 16 : "100%" }}
                >
                    {popoverContent}
                </Popover>
            ) : (
                <>{popoverContent}</>
            )}
        </>
    );
};

export default AutoPlay;
